import React, { useState } from 'react';
import { Input, Select, Space, DatePicker } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { ArrowDownTrayIcon } from '@heroicons/react/20/solid';
import { Button } from '@clockout-dev/design-elements';
import { exportReconciliationToCSV } from '../../../utils/exportUtils';

const { RangePicker } = DatePicker;
const { Option } = Select;

const ReconciliationTableActions = ({ reconciliation, setRows, rows }) => {
    const [searchText, setSearchText] = useState('');
    const [dateRange, setDateRange] = useState(null);
    const [daysPastDue, setDaysPastDue] = useState('all');

    const handleSearch = (value) => {
        setSearchText(value);
        filterData(value, dateRange, daysPastDue);
    };

    const handleDateRange = (dates) => {
        setDateRange(dates);
        filterData(searchText, dates, daysPastDue);
    };

    const handleDaysPastDueChange = (value) => {
        setDaysPastDue(value);
        filterData(searchText, dateRange, value);
    };

    const handleDownloadExcel = () => {
        exportReconciliationToCSV(rows || reconciliation);
    };

    const filterData = (search, dates, selectedDaysPastDue) => {
        let filteredData = [...reconciliation];

        if (search) {
            filteredData = filteredData.filter((item) => {
                const searchLower = search.toLowerCase();
                return (
                    item.account_name?.toLowerCase().includes(searchLower) ||
                    item.email?.toLowerCase().includes(searchLower) ||
                    item.client_id?.toLowerCase().includes(searchLower)
                );
            });
        }

        if (dates) {
            filteredData = filteredData.filter((item) => {
                const itemDate = new Date(item.scheduled_for);
                return itemDate >= dates[0].startOf('day') && itemDate <= dates[1].endOf('day');
            });
        }

        if (selectedDaysPastDue !== 'all') {
            filteredData = filteredData.filter((item) => {
                const days = item.days_past_due;
                switch (selectedDaysPastDue) {
                    case 'current':
                        return days === 0;
                    case '1-30':
                        return days > 0 && days <= 30;
                    case '31-90':
                        return days > 30 && days <= 90;
                    case '90+':
                        return days > 90;
                    default:
                        return true;
                }
            });
        }

        setRows(filteredData);
    };

    return (
        <div style={{ marginBottom: 16 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                <span style={{ fontSize: 16, fontWeight: 600 }}>Filters</span>
                <Button icon={<ArrowDownTrayIcon />} onClick={handleDownloadExcel}>
                    Download Excel
                </Button>
            </div>
            <Space style={{ marginBottom: 16 }} wrap>
                <Input
                    placeholder="Search by account name, email, or client ID"
                    onChange={(e) => handleSearch(e.target.value)}
                    prefix={<SearchOutlined />}
                    style={{ width: 300 }}
                />
                <RangePicker onChange={handleDateRange} placeholder={['Scheduled From', 'Scheduled To']} />
                <Select defaultValue="all" style={{ width: 150 }} onChange={handleDaysPastDueChange}>
                    <Option value="all">All Past Due</Option>
                    <Option value="current">Current (0 days)</Option>
                    <Option value="1-30">1-30 days</Option>
                    <Option value="31-90">31-90 days</Option>
                    <Option value="90+">90+ days</Option>
                </Select>
            </Space>
        </div>
    );
};

export default ReconciliationTableActions;
